 <template>
  <div class="c-restrictiveComponent">
    <div class="c-restrictiveComponent_wrapDescription">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" v-bind:svg-inline="''" v-bind:class="'c-restrictiveComponent_icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path data-name="Caminho 4213" d="M0 30A30 30 0 1030 0 30 30 0 000 30z" fill="#f6f6f6"/><path data-name="Caminho 4214" d="M17.514 50.635c0 .862 5.59 1.561 12.486 1.561s12.486-.7 12.486-1.561-5.59-1.561-12.486-1.561-12.486.7-12.486 1.561z" fill="#ffdc91" stroke="#3d3d3d"/><path data-name="Caminho 4215" d="M16.212 24.205h27.577v25.058H16.212z" fill="#fff"/><path data-name="Caminho 4216" d="M16.212 24.205h27.577v25.058H16.212z" fill="none" stroke="#3d3d3d" stroke-linecap="round" stroke-linejoin="round"/><path data-name="Caminho 4217" d="M32.378 37.101a2.377 2.377 0 10-3.8 1.891v2.85a1.425 1.425 0 102.85 0v-2.85a2.368 2.368 0 00.95-1.891z" fill="#ffdc91" stroke="#3d3d3d" stroke-linecap="round" stroke-linejoin="round"/><path data-name="Caminho 4218" d="M40.936 16.125a10.936 10.936 0 10-21.872 0v8.08h4.752v-8.08a6.181 6.181 0 0112.362 0v8.08h4.758z" fill="#ffdc91"/><path data-name="Caminho 4219" d="M40.936 16.125a10.936 10.936 0 10-21.872 0v8.08h4.752v-8.08a6.181 6.181 0 0112.362 0v8.08h4.758z" fill="none" stroke="#3d3d3d" stroke-linecap="round" stroke-linejoin="round"/></svg>
      <div class="c-restrictiveComponent_description">
        Libere <strong>{{ text }}</strong> assinando um plano CoteiBem para {{ companyName }}!
      </div>
    </div>
    <a class="c-restrictiveComponent_button" :href="planUpgrade.index">Ver benefícios</a>
  </div>
</template>

<script lang="ts">
import Vue, { PropOptions } from 'vue'
import { mapState, mapActions } from 'vuex'
import { StoreState } from 'Types'
import { planUpgrade } from 'routes'

const initialState = () => ({
  planUpgrade
})

export default Vue.extend({
  data() {
    return initialState()
  },

  props: {
    text: String,
    companyName: String
  },

  computed: {

  },

  methods: {}
})
</script>

<style lang="scss">
@import "~css/_references";
@import "~css/Modules/button";

.c-restrictiveComponent {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 36px;

  &_icon {
    min-width: 60px;
    height: 60px;
  }

  &_wrapDescription {
    display: flex;
    gap: 16px;
  }

  &_description {
    @include f-fontSystem(20px);
  }

  &_button {
    @extend .m-button;
    @extend .m-button--primary;
    width: 180px;
    flex-shrink: 0;
  }
}


@include f-media('<tablet') {
  .c-restrictiveComponent {
    flex-direction: column;
    align-items: flex-start;

    &_wrapDescription {
      display: flex;
      gap: 12px;
    }

    &_description {
      margin: 0;
      font-size: 16px;
    }

    &_icon {
      min-width: 40px;
      height: 40px;
    }

  }
}
</style>